import styled from 'styled-components/native';

export default styled.TouchableOpacity<{ expired?: boolean }>`
  ${({ expired }) => expired && `opacity: 0.5;`}
`;
